module.exports = "<svg viewBox=\"0 0 24 28\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M22.5 27.43H.83c-.46 0-.83-.4-.83-.86v-.86c0-5.05 3.96-9.56 8.98-10.8-2.8-1.1-4.8-3.9-4.8-7.2 0-4.24 3.35-7.7 7.5-7.7 4.12 0 7.5 3.46 7.5 7.7 0 3.3-2.02 6.1-4.83 7.2 5.02 1.24 8.98 5.75 8.98 10.8v.87c0 .47-.37.86-.83.86zm-5-19.72c0-3.3-2.62-6-5.83-6-3.22 0-5.84 2.7-5.84 6 0 3.32 2.62 6 5.84 6 3.2 0 5.83-2.68 5.83-6zm-5.83 8.6c-5.33 0-10 4.4-10 9.4h20c0-5-4.68-9.4-10-9.4z\" fill=\"#394F5A\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/images/svg/participant.svg
// module id = mXkB
// module chunks = 89